import { OrganizationIntegrationAccountItem } from "@common/schemas/organization-connection-groups.schema";

/**
 * How an account row is named wherever it is referred to — the table's Account
 * column and any dialog acting on that row. Kept in one place so the mask
 * formatting cannot drift between them.
 */
export const integrationAccountLabel = (
    item: OrganizationIntegrationAccountItem,
): string => {
    const { name, accountNumberMask } = item.account;
    const base = name ?? "Account";
    return accountNumberMask ? `${base} ••${accountNumberMask}` : base;
};
